import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  CheckOutlined,
  CloseOutlined,
  CreditCardOutlined,
  DeleteOutlined,
  ExclamationCircleFilled,
  EyeOutlined,
  PlusOutlined,
  StarFilled,
  UserAddOutlined,
  UserDeleteOutlined,
} from "@ant-design/icons";
import { uuid } from "@ant-design/plots/es/utils";
import { Button, Dropdown, Modal, Space, Tag } from "antd";
import { DotVerticalIcon, ReceiptViewIcon, TwoUsersIcon } from "assets/icons";
import { NoticeboardIcon, SettingIcon, SubcriptionIcon } from "assets/icons";
import {
  STATUS_TYPE,
  STORAGE_KEYS,
  USER_TYPE,
  WORKSPACE_USER_TYPE,
} from "constants/appConstant";
import { AuthInfo, clearAuthData, getMe } from "stores/slices/auth";
import { setHeaderTitle, setIsRefresh } from "stores/slices/layout";
import {
  doDeleteWorkspace,
  doGetWorkspacePage,
  doUpdateWorkspaceStatus,
  getRealtimeWorkspace,
  numOfEls,
} from "stores/slices/workspace";
import StorageHelper from "utils/storeHelper";

import AppButton from "components/button";
import ModalForm from "components/forms/components/modalForm";
import AppTable from "components/table";

import store from "../../../stores/configStore";
import {
  doGetSubscriptionAll,
  getAllSubscriptions,
} from "../../../stores/slices/subscriptions";
import { doGetUserInfo } from "../../../stores/slices/user";
import WorkspaceForm from "../forms/workspaceForm";
const WorkspacePage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const authInfo = useSelector(AuthInfo);

  const noOfElements = useSelector(numOfEls);
  const workspaceRealtime = useSelector(getRealtimeWorkspace);
  const listSubscriptions = useSelector(getAllSubscriptions);
  const [isOpenAddWorkspace, setIsOpenAddWorkspace] = useState(false);
  const [isViewWorkspace, setIsViewWorkspace] = useState(false);
  const [workspaceSelected, setWorkspaceSelected] = useState(null);
  const [userDetail, setUserDetail] = useState({});
  const [searchParams, setSearchParams] = useState({
    sortFieldWorkspace: "createdTime",
    sortDirection: "DESC",
    pageNumber: 1,
    pageSize: 10,
    statuses: [STATUS_TYPE.ACTIVE, STATUS_TYPE.INACTIVE],
  });
  const [columns, setColumns] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isOpenModalDelete, setIsOpenModalDelete] = useState(false);
  const [selectedWorkspaceDelete, setSelectedWorkspaceDelete] = useState();
  const [isOpenModalChangeStatus, setIsOpenModalChangeStatus] = useState(false);
  const [isChanging, setIsChanging] = useState(false);
  const [selectedWorkspaceChange, setSelectedWorkspaceChange] = useState();
  const [listAllSubscriptions, setListAllSubscriptions] = useState([]);

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
  };

  const handleFilter = (selectedKeys, confirm) => {
    confirm();
  };

  const handleTableChange = (pagination, filters, sorter) => {
    let newParams = {};
    filters.name &&
      (newParams = {
        ...newParams,
        searchKeyName: filters.name[0],
      });

    filters.contactName &&
      (newParams = {
        ...newParams,
        searchKeyContactName: filters.contactName[0],
      });

    filters.contactEmail &&
      (newParams = {
        ...newParams,
        searchKeyContactEmail: filters.contactEmail[0],
      });

    newParams = {
      ...newParams,
      statuses: filters.status
        ? filters.status
        : [STATUS_TYPE.ACTIVE, STATUS_TYPE.INACTIVE],
    };

    if (sorter && sorter.columnKey && sorter.order) {
      newParams = {
        ...newParams,
        sortFieldWorkspace: sorter.columnKey,
        sortDirection: sorter.order === "ascend" ? "ASC" : "DESC",
      };
    } else {
      newParams = {
        ...newParams,
        sortFieldWorkspace: "createdTime",
        sortDirection: "DESC",
      };
    }
    newParams = {
      ...newParams,
      pageNumber: pagination.current,
      pageSize: pagination.pageSize,
    };

    setSearchParams(newParams);
  };

  const showDeleteConfirm = record => {
    setSelectedWorkspaceDelete(record);
    setIsOpenModalDelete(true);
  };

  const showChangeStatusConfirm = record => {
    setSelectedWorkspaceChange(record);
    setIsOpenModalChangeStatus(true);
  };

  const actionOptionItems = record => {
    return [
      {
        key: "1",
        label: <span>{t("workspace.viewAndEdit")}</span>,
        icon: (
          <span style={{ marginInlineEnd: 8, fontSize: 20 }}>
            <EyeOutlined />
          </span>
        ),
        disabled:
          authInfo.type === USER_TYPE.USER &&
          record.workspaceUser?.type !== WORKSPACE_USER_TYPE.ADMIN,
        onClick: () => {
          setIsViewWorkspace(true);
          setWorkspaceSelected(record);
          setIsOpenAddWorkspace(true);
        },
      },
      {
        key: "2",
        label: <span>{t("workspace.users")}</span>,
        icon: (
          <span style={{ marginInlineEnd: 8 }}>
            <TwoUsersIcon />
          </span>
        ),
        disabled:
          (record.status !== STATUS_TYPE.ACTIVE &&
            record.status !== STATUS_TYPE.INACTIVE) ||
          (record.workspaceUser &&
            record.workspaceUser.type === WORKSPACE_USER_TYPE.OPERATOR),
        onClick: () => {
          navigate(`/admin/users/workspace/${record.id}`);
        },
      },
      {
        key: "3",
        label: <span>{t("workspace.viewInvoices")}</span>,
        icon: (
          <span style={{ marginInlineEnd: 8 }}>
            <ReceiptViewIcon />
          </span>
        ),
        disabled:
          authInfo.type === USER_TYPE.USER &&
          record.workspaceUser?.type !== WORKSPACE_USER_TYPE.ADMIN,
        onClick: () => {
          navigate(`/admin/invoices/${record.id}`);
        },
      },
      {
        key: "4",
        label: <span>{t("workspace.subscription")}</span>,
        icon: (
          <span style={{ marginInlineEnd: 8 }}>
            <SubcriptionIcon size={20} />
          </span>
        ),
        onClick: () => {
          navigate(`/admin/subscriptions/${record?.id}`, {
            state: {
              name: record.name,
              subscriptionId: record?.subscriptionPackage?.id,
            },
          });
        },
        disabled:
          !record?.subscriptionPackage ||
          authInfo.workspaceRole === WORKSPACE_USER_TYPE.OPERATOR,
      },
      {
        key: "5",
        label: <span>{t("workspace.noticeBoard")}</span>,
        icon: (
          <span style={{ marginInlineEnd: 8 }}>
            <NoticeboardIcon size={20} />
          </span>
        ),
        onClick: () => {
          navigate(`/admin/notice/${record?.id}`, {
            state: {
              name: record.name,
            },
          });
        },
      },
      {
        key: "6",
        label: <span>{t("workspace.setting")}</span>,
        icon: (
          <span style={{ marginInlineEnd: 8 }}>
            <SettingIcon style={{ fontSize: "18px", padding: "1px" }} />
          </span>
        ),
        onClick: () => {
          navigate(`/admin/setting/${record.id}`, {
            state: {
              name: record.name,
            },
          });
        },
      },
      {
        key: "7",
        label: <span>{t("workspace.manageCard")}</span>,
        icon: (
          <span style={{ marginInlineEnd: 8 }}>
            <CreditCardOutlined style={{ fontSize: "18px", padding: "1px" }} />
          </span>
        ),
        disabled:
          authInfo.type !== USER_TYPE.USER ||
          record.workspaceUser?.type !== WORKSPACE_USER_TYPE.ADMIN,
        onClick: () => {
          navigate(`/admin/workspaces/${record.id}/card`);
        },
      },
      {
        key: "8",
        danger: true,
        label: <span>{t("workspace.delete")}</span>,
        icon: <DeleteOutlined />,
        disabled:
          authInfo.type === USER_TYPE.USER &&
          record.workspaceUser?.type !== WORKSPACE_USER_TYPE.ADMIN,
        onClick: () => {
          showDeleteConfirm(record);
        },
      },
      {
        key: "9",
        danger: record.status === STATUS_TYPE.ACTIVE,
        label: (
          <span>
            {record.status === STATUS_TYPE.ACTIVE
              ? t("workspace.makeInactive")
              : t("workspace.activate")}
          </span>
        ),
        disabled:
          authInfo.type === USER_TYPE.USER &&
          record.workspaceUser?.type !== WORKSPACE_USER_TYPE.ADMIN,
        icon:
          record.status === STATUS_TYPE.ACTIVE ? (
            <UserDeleteOutlined />
          ) : (
            <UserAddOutlined style={{ fontSize: 20 }} />
          ),
        onClick: () => {
          showChangeStatusConfirm(record);
        },
      },
    ];
  };

  const generateTableColumns = () => {
    const cols = [
      {
        title: t("workspace.workspace"),
        width: 110,
        dataIndex: "name",
        key: "name",
        sorter: true,
        isSearchable: true,
        searchPlaceholder:
          "Search by " + t("workspace.workspace").toString().toLowerCase(),
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: t("workspace.contactName"),
        width: 110,
        dataIndex: "contactName",
        key: "contactName",
        sorter: true,
        isSearchable: true,
        searchPlaceholder:
          "Search by " + t("workspace.contactName").toString().toLowerCase(),
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: t("workspace.email"),
        width: 120,
        dataIndex: "contactEmail",
        key: "contactEmail",
        defaultSortOrder: "ascend",
        sorter: true,
        isSearchable: true,
        searchPlaceholder:
          "Search by " + t("workspace.email").toString().toLowerCase(),
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: t("workspace.usage"),
        width: 150,
        dataIndex: "numberOfCustomer",
        key: "numberOfCustomer",
        ellipsis: {
          showTitle: false,
        },
        render: (_, record) => (
          <>
            <div>{`${t("label.customers")}: ${
              record?.numberOfCustomer.toLocaleString() || 0
            }/${
              record?.subscriptionPackage?.numberContact.toLocaleString() || 0
            }`}</div>
            <div>{`${t("label.services")}: ${
              record?.numberOfServices.toLocaleString() || 0
            }/${
              record?.subscriptionPackage?.numberInc.toLocaleString() || 0
            } `}</div>
            <div>{`${t("label.seats")}: ${
              record?.numberOfSeat.toLocaleString() || 0
            }/${
              record?.subscriptionPackage?.perSeatInc.toLocaleString() || 0
            } `}</div>
          </>
        ),
      },
      {
        title: t("workspace.subscription"),
        width: 100,
        dataIndex: "subscriptionPackage",
        key: "subscriptionPackageName",
        sorter: true,
        ellipsis: {
          showTitle: true,
        },
        render: (_, { subscriptionPackage }) => (
          <>
            <div style={{ width: "fit-content" }}>
              <Tag
                color={"#599CE7"}
                icon={<StarFilled />}
                style={{ display: "flex", alignItems: "center" }}
              >
                <div style={{ display: "inline-grid" }}>
                  <span
                    style={{ overflow: "hidden", textOverflow: "ellipsis" }}
                  >
                    {subscriptionPackage?.name.toUpperCase()}
                  </span>
                </div>
              </Tag>
            </div>
          </>
        ),
      },
      {
        title: t("workspace.status"),
        width: 85,
        dataIndex: "status",
        key: "status",
        ellipsis: {
          showTitle: false,
        },
        filters: [
          {
            text: t("status.active"),
            value: STATUS_TYPE.ACTIVE,
          },
          {
            text: t("status.inactive"),
            value: STATUS_TYPE.INACTIVE,
          },
        ],
        render: (_, { status }) => (
          <>
            <div>
              <Tag
                color={status === STATUS_TYPE.ACTIVE ? "#0E9154" : "#A9122B"}
                key={status}
                icon={
                  status === STATUS_TYPE.ACTIVE ? (
                    <CheckOutlined />
                  ) : (
                    <CloseOutlined />
                  )
                }
              >
                {status.toUpperCase()}
              </Tag>
            </div>
          </>
        ),
      },
      {
        title: t("workspace.actions"),
        width: 50,
        key: "actions",
        ellipsis: {
          showTitle: false,
        },
        render: record => {
          return (
            <>
              <Space
                size={"middle"}
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Dropdown
                  menu={{
                    items: actionOptionItems(record),
                  }}
                  overlayClassName="workspaceActionDropdown"
                  placement="bottomRight"
                  trigger={"click"}
                >
                  <Button
                    type="text"
                    shape="circle"
                    size="middle"
                    icon={<DotVerticalIcon />}
                  />
                </Dropdown>
              </Space>
            </>
          );
        },
      },
    ];
    setColumns(cols);
  };

  useEffect(() => {
    dispatch(setHeaderTitle("workspaces"));
    getUserDetail().then(res => {
      setUserDetail(res);
    });
    if (authInfo.type === USER_TYPE.SUPER_ADMIN) {
      handleLoadAllSubscription();
    }
  }, []);

  useEffect(() => {
    if (listSubscriptions && listSubscriptions.length > 0) {
      let list = [];
      listSubscriptions.forEach(item => {
        list.push({
          id: item.id,
          name: item.name,
        });
      });
      setListAllSubscriptions(list);
    }
  }, [listSubscriptions]);

  useEffect(() => {
    if (workspaceRealtime !== undefined && workspaceRealtime !== null) {
      const { properties } = workspaceRealtime;
      if (properties !== undefined && properties !== null && properties.id) {
        dispatch(setIsRefresh(uuid()));
      }
    }
  }, [workspaceRealtime?.properties?.id]);

  useEffect(() => {
    generateTableColumns();
  }, [noOfElements]);

  const getUserDetail = async () => {
    const { payload } = await dispatch(doGetUserInfo(authInfo.id));
    return payload;
  };

  const handleDelete = async () => {
    const result = await dispatch(
      doDeleteWorkspace(selectedWorkspaceDelete.id)
    );
    setIsOpenModalDelete(false);
    setIsDeleting(false);
    if (result && result.payload.status === 200) {
      if (selectedWorkspaceDelete.id.toString() === authInfo.workspaceId) {
        StorageHelper.removeCookie(STORAGE_KEYS.token);
        store.dispatch(clearAuthData());
      } else {
        if (selectedWorkspaceDelete.subscriptionPackage?.default) {
          dispatch(getMe());
        }
      }
      if (searchParams.pageNumber > 1 && noOfElements === 1) {
        const newSearchParam = {
          ...searchParams,
          pageNumber: searchParams.pageNumber - 1,
        };
        setSearchParams(newSearchParam);
      }
      dispatch(setIsRefresh(uuid()));
    }
    setSelectedWorkspaceDelete();
  };

  const handleChangeStatus = async () => {
    const result = await dispatch(
      doUpdateWorkspaceStatus({
        id: selectedWorkspaceChange.id,
        status:
          selectedWorkspaceChange.status === STATUS_TYPE.ACTIVE
            ? STATUS_TYPE.INACTIVE
            : STATUS_TYPE.ACTIVE,
      })
    );
    setIsChanging(false);
    setIsOpenModalChangeStatus(false);
    if (result && result.payload.status === 200) {
      if (
        selectedWorkspaceChange.id.toString() === authInfo.workspaceId &&
        selectedWorkspaceChange.status === STATUS_TYPE.ACTIVE
      ) {
        StorageHelper.removeCookie(STORAGE_KEYS.token);
        setTimeout(() => {
          navigate("/auth/sign-in");
        }, 1000);
      }
      dispatch(setIsRefresh(uuid()));
    }
    setSelectedWorkspaceChange();
  };

  const handleTitleDelete = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <ExclamationCircleFilled style={{ color: "#faad14", fontSize: 24 }} />
        <span style={{ marginLeft: 10, fontSize: 16 }}>
          {t("workspace.deleteWorkspace")}
        </span>
      </div>
    );
  };

  const handleTitleChangeStatus = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <ExclamationCircleFilled style={{ color: "#faad14", fontSize: 24 }} />
        <span style={{ marginLeft: 10, fontSize: 16 }}>
          {selectedWorkspaceChange
            ? selectedWorkspaceChange.status === STATUS_TYPE.ACTIVE
              ? t("workspace.makeInactive")
              : t("workspace.activate")
            : ""}
        </span>
      </div>
    );
  };

  const handleLoadAllSubscription = async () => {
    await dispatch(doGetSubscriptionAll({}));
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "end",
          marginBottom: 24,
        }}
      >
        <AppButton
          label={t("button.add")}
          icon={<PlusOutlined />}
          color={"primary"}
          type="primary"
          onClick={() => {
            if (authInfo.maxFreeWorkspace) {
              Modal.warning({
                title: t("workspace.subscriptionPackageInUseTitle"),
                icon: <ExclamationCircleFilled />,
                content: t("workspace.subscriptionPackageInUseMsg"),
              });
            } else {
              setIsViewWorkspace(false);
              setWorkspaceSelected(null);
              setIsOpenAddWorkspace(true);
            }
          }}
          style={{
            marginLeft: "auto",
            minWidth: "auto",
          }}
        />
      </div>
      <div>
        <AppTable
          searchParam={searchParams}
          api={doGetWorkspacePage(searchParams)}
          handleSearch={handleSearch}
          handleTableChange={handleTableChange}
          handleFilter={handleFilter}
          columns={columns}
          setSearchParam={setSearchParams}
        />
      </div>
      <ModalForm
        title={
          isViewWorkspace
            ? t("workspace.viewWorkspace")
            : workspaceSelected
            ? t("workspace.updateWorkspace")
            : t("workspace.addWorkspace")
        }
        isOpen={isOpenAddWorkspace}
        destroyOnClose={true}
        maskClosable={false}
        onCancel={() => {
          setIsViewWorkspace(false);
          setIsOpenAddWorkspace(false);
          setWorkspaceSelected(null);
        }}
        labelSubmit={t("label.save")}
        customWidth={700}
        footer={false}
      >
        <WorkspaceForm
          userDetail={userDetail}
          authInfo={authInfo}
          setIsOpenWorkspace={setIsOpenAddWorkspace}
          workspaceSelected={workspaceSelected}
          setWorkspaceSelected={setWorkspaceSelected}
          listAllSubscriptions={listAllSubscriptions}
          isView={isViewWorkspace}
          onChangeViewFrm={value => setIsViewWorkspace(value)}
        />
      </ModalForm>
      <ModalForm
        isOpen={isOpenModalDelete}
        type="confirm"
        title={handleTitleDelete()}
        onCancel={() => {
          setIsOpenModalDelete(false);
        }}
        okType={"danger"}
        danger={true}
        maskClosable={false}
        footer={[
          <AppButton
            key="button"
            label={t("button.no")}
            color={"grey"}
            loading={isDeleting}
            disabled={isDeleting}
            htmlType="button"
            onClick={() => {
              setIsOpenModalDelete(false);
            }}
          />,
          <AppButton
            key="button"
            color="red"
            label={t("button.yes")}
            loading={isDeleting}
            disabled={isDeleting}
            onClick={() => {
              setIsDeleting(true);
              handleDelete(selectedWorkspaceDelete);
            }}
          />,
        ]}
      >
        <div style={{ height: 50, marginLeft: 35, fontSize: 14 }}>
          {t("text.deleteWorkspace")}
        </div>
      </ModalForm>

      <ModalForm
        isOpen={isOpenModalChangeStatus}
        type="confirm"
        title={handleTitleChangeStatus()}
        onCancel={() => {
          setIsOpenModalChangeStatus(false);
        }}
        okType={"danger"}
        danger={true}
        maskClosable={false}
        footer={[
          <AppButton
            key="button"
            label={t("button.no")}
            color={"grey"}
            loading={isChanging}
            disabled={isChanging}
            htmlType="button"
            onClick={() => {
              setIsOpenModalChangeStatus(false);
            }}
          />,
          <AppButton
            key="button"
            color="red"
            label={t("button.yes")}
            loading={isChanging}
            disabled={isChanging}
            onClick={() => {
              setIsChanging(true);
              handleChangeStatus();
            }}
          />,
        ]}
      >
        <div style={{ height: 50, marginLeft: 35, fontSize: 14 }}>
          {selectedWorkspaceChange
            ? selectedWorkspaceChange.status === STATUS_TYPE.ACTIVE
              ? t("workspace.makeInactiveMsg")
              : t("workspace.activateMsg")
            : ""}
        </div>
      </ModalForm>
    </>
  );
};

export default WorkspacePage;
